import { usePortfolioPerformanceTimeseries } from '@/hooks/portfolio/usePortfolioPerformanceTimeseries';

import { useUtcOffsetPeriodMap } from '../hooks';

import type { PerformancePeriod } from '../types';

import { Chart } from './Chart';

type Props = {
  market: string;
  period: PerformancePeriod;
  portfolioId: string;
};

export const DemoPortfolioPerformanceChart = ({
  market,
  period,
  portfolioId,
}: Props) => {
  const periodMap = useUtcOffsetPeriodMap();

  const startTimestamp = periodMap[period];
  const endTimestamp = periodMap.NOW;

  const { data, status } = usePortfolioPerformanceTimeseries({
    portfolioId,
    startTimestamp,
    endTimestamp,
  });

  return (
    <Chart
      startTimestamp={startTimestamp}
      endTimestamp={endTimestamp}
      timeseriesStatus={status}
      market={market}
      period={period}
      timeseries={data}
    />
  );
};
